(() => {
  'use strict';

  const currencySymbols = {
    AED: 'د.إ', AFN: '؋', ALL: 'L', AMD: '֏', ANG: 'ƒ', AOA: 'Kz', ARS: '$', AUD: '$', AWG: 'ƒ', AZN: '₼',
    BAM: 'KM', BBD: '$', BDT: '৳', BGN: 'лв', BHD: 'د.ب', BIF: 'Fr', BMD: '$', BND: '$', BOB: 'Bs.', BRL: 'R$', BSD: '$', BTN: 'Nu.', BWP: 'P', BYN: 'Br', BZD: '$',
    CAD: '$', CDF: 'Fr', CHF: 'CHF', CLP: '$', CNY: '¥', COP: '$', CRC: '₡', CUP: '$', CVE: '$', CZK: 'Kč',
    DJF: 'Fr', DKK: 'kr', DOP: '$', DZD: 'دج',
    EGP: '£', ERN: 'Nfk', ETB: 'Br', EUR: '€',
    FJD: '$', FKP: '£',
    GBP: '£', GEL: '₾', GHS: '₵', GIP: '£', GMD: 'D', GNF: 'Fr', GTQ: 'Q', GYD: '$',
    HKD: '$', HNL: 'L', HTG: 'G', HUF: 'Ft',
    IDR: 'Rp', ILS: '₪', INR: '₹', IQD: 'ع.د', IRR: '﷼', ISK: 'kr',
    JMD: '$', JOD: 'د.ا', JPY: '¥',
    KES: 'Sh', KGS: 'с', KHR: '៛', KMF: 'Fr', KPW: '₩', KRW: '₩', KWD: 'د.ك', KYD: '$', KZT: '₸',
    LAK: '₭', LBP: 'ل.ل', LKR: 'Rs', LRD: '$', LSL: 'L', LYD: 'ل.د',
    MAD: 'د.م.', MDL: 'L', MGA: 'Ar', MKD: 'ден', MMK: 'K', MNT: '₮', MOP: 'MOP$', MRU: 'UM', MUR: '₨', MVR: 'Rf', MWK: 'MK', MXN: '$', MYR: 'RM', MZN: 'MT',
    NAD: '$', NGN: '₦', NIO: 'C$', NOK: 'kr', NPR: '₨', NZD: '$',
    OMR: 'ر.ع.',
    PAB: 'B/.', PEN: 'S/', PGK: 'K', PHP: '₱', PKR: '₨', PLN: 'zł', PYG: '₲',
    QAR: 'ر.ق',
    RON: 'lei', RSD: 'дин', RUB: '₽', RWF: 'Fr',
    SAR: 'ر.س', SBD: '$', SCR: '₨', SDG: 'ج.س.', SEK: 'kr', SGD: '$', SHP: '£', SLE: 'Le', SLL: 'Le', SOS: 'Sh', SRD: '$', SSP: '£', STN: 'Db', SYP: '£', SZL: 'L',
    THB: '฿', TJS: 'ЅМ', TMT: 'm', TND: 'د.ت', TOP: 'T$', TRY: '₺', TTD: '$', TWD: 'NT$', TZS: 'Sh',
    UAH: '₴', UGX: 'Sh', USD: '$', UYU: '$', UZS: 'сўм',
    VES: 'Bs.', VND: '₫', VUV: 'Vt',
    WST: 'T',
    XAF: 'Fr', XCD: '$', XOF: 'Fr', XPF: '₣',
    YER: '﷼',
    ZAR: 'R', ZMW: 'ZK', ZWL: '$'
  };

  const currencyCodes = Object.keys(currencySymbols);
  const codePattern = new RegExp(`(^|[^A-Za-z])(${currencyCodes.join('|')})(?=$|[^A-Za-z])`, 'g');
  const exactCodePattern = new RegExp(`^\\s*(${currencyCodes.join('|')})\\s*$`);

  const priceSelector = [
    '.money',
    'sale-price',
    'compare-at-price',
    'unit-price',
    'price-list',
    '.price-list',
    '.cart-drawer__button-price',
    '.line-item__price',
    '.product-card__price',
    '[data-bundle-total]',
    '[data-bundle-discount]',
    '[data-bundle-final]',
    '[data-price]'
  ].join(',');

  const currencyUiSelector = [
    '[data-currency]',
    '[data-currency-code]',
    '[class*="currency"]',
    '[id*="currency"]'
  ].join(',');

  function removeCurrencyCode(text) {
    return text
      .replace(codePattern, (match, prefix) => prefix)
      .replace(/[\u00A0 ]{2,}/g, ' ')
      .replace(/\s+([,.;:])/g, '$1')
      .trimEnd();
  }

  function sanitizeTextNode(textNode, forcePriceContext = false) {
    const value = textNode.nodeValue;
    if (!value || !/[A-Z]{3}/.test(value)) return;

    const parent = textNode.parentElement;
    if (!parent) return;

    const isPriceContext = forcePriceContext || Boolean(parent.closest(priceSelector));
    const isCurrencyUi = Boolean(parent.closest(currencyUiSelector));

    if (isCurrencyUi) {
      const exactMatch = value.match(exactCodePattern);
      if (exactMatch && currencySymbols[exactMatch[1]]) {
        const leading = value.match(/^\s*/)?.[0] || '';
        const trailing = value.match(/\s*$/)?.[0] || '';
        textNode.nodeValue = `${leading}${currencySymbols[exactMatch[1]]}${trailing}`;
        return;
      }
    }

    if (isPriceContext) {
      textNode.nodeValue = removeCurrencyCode(value);
    }
  }

  function sanitizeElement(element) {
    if (!(element instanceof Element)) return;

    const candidates = new Set();

    if (element.matches(priceSelector) || element.matches(currencyUiSelector)) {
      candidates.add(element);
    }

    element.querySelectorAll(priceSelector).forEach((node) => candidates.add(node));
    element.querySelectorAll(currencyUiSelector).forEach((node) => candidates.add(node));

    candidates.forEach((candidate) => {
      const walker = document.createTreeWalker(candidate, NodeFilter.SHOW_TEXT);
      let textNode;
      while ((textNode = walker.nextNode())) {
        sanitizeTextNode(textNode, candidate.matches(priceSelector));
      }
    });
  }

  function sanitizeNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      sanitizeTextNode(node);
      return;
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      sanitizeElement(node);
    }
  }

  function sanitizePage() {
    sanitizeElement(document.documentElement);
  }

  sanitizePage();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sanitizePage, { once: true });
  }

  let queued = false;
  const pendingNodes = new Set();

  const flush = () => {
    queued = false;
    pendingNodes.forEach(sanitizeNode);
    pendingNodes.clear();
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        pendingNodes.add(mutation.target);
      }

      mutation.addedNodes.forEach((node) => pendingNodes.add(node));
    });

    if (!queued) {
      queued = true;
      requestAnimationFrame(flush);
    }
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true
  });
})();
